import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {auth} from 'main/tools';
import {HRDashboardPageState} from '../state';
import {Layout, Panel, Display} from 'shared/components';
import {Feed} from '../feed';
import {Insights} from '../insights';
import {CompanyDetails} from '../company_details';
import {CompanyLinks} from '../company_links';
import {TimeOff} from '../time_off';
import {OutOfOffice} from '../out_of_office';
import {WhatsGoingOn} from '../whats_going_on';
import {PayrollDates} from '../payroll_dates';
import {NmbrPayrollInfo} from '../nmbr_payroll_dates';
import CompanyFiles from '../company_files/components/CompanyFiles';

const HRDashboardPage = observer(({uiState}) => {
  const {
    emojiReady, celebrations, staffCount, timeOffAccounts, ptoRequests, sortedCompanyLinks, folderlessFiles, companyFileFolders, company,
    payPeriod, paySchedules, loadingPaySchedules, payScheduleErrors, insightsInboxSummary, insightsPTOSummary, insightsNewHireSummary, insightsJobApplicantSummary
  } = uiState;

  return (
    <React.Fragment>
      <Display
        title={uiState.greeting}
        documentTitle={t('hr_dashboard.Home')}
      />
      <Layout>
        <div className='HRDashboardWidgets nm'>
          {auth.user.admin && <Insights
            emojiReady={emojiReady}
            inboxSummary={insightsInboxSummary}
            ptoSummary={insightsPTOSummary}
            newHireSummary={insightsNewHireSummary}
            jobApplicantSummary={insightsJobApplicantSummary}
          />}
          <Panel.Stack loose className='sidebar'>
            <CompanyDetails staffCount={staffCount} initialCompany={company}/>
            {auth.company.nmbrEnabled && (auth.hasAccess('::PAYROLL') || auth.employee.hasNmbrPayroll) && <NmbrPayrollInfo emojiReady={emojiReady} paySchedules={paySchedules} isLoading={loadingPaySchedules} errors={payScheduleErrors}/>}
            {auth.employee && auth.employee.hasTimeOffPolicy && <TimeOff emojiReady={emojiReady} accounts={timeOffAccounts}/>}
            <PayrollDates emojiReady={emojiReady} payPeriod={payPeriod}/>
            {auth.user.peopleOffTodayVisibility && <OutOfOffice emojiReady={emojiReady} ptoRequests={ptoRequests}/>}
            <CompanyLinks emojiReady={emojiReady} companyLinks={sortedCompanyLinks}/>
            <CompanyFiles emojiReady={emojiReady} folderlessFiles={folderlessFiles} companyFileFolders={companyFileFolders}/>
          </Panel.Stack>
          <WhatsGoingOn emojiReady={emojiReady}/>
          <Feed emojiReady={emojiReady} celebrations={celebrations}/>
        </div>
      </Layout>
    </React.Fragment>
  );
});

export default withState(HRDashboardPage, HRDashboardPageState);
